export default __webpack_public_path__ + "static/media/todo.c7f21eac.bin";